<div class="container bg-white">
  <h5 class="text-primary">{{ 'registration.marketing.page.title' | translate }}</h5>

  <hr />
  <div class="content-center">
    <img class="logo" [src]="'placeholders/benefits.png' | contentAssetImage" draggable="false" />

    <h4 class="text-primary text-center">{{ 'registration.marketing.subheading' | translate }}</h4>

    <div
      class="font-size-12 text-center"
      [innerHTML]="'registration.marketing.description' | translate | markdownTranslate"
    ></div>
  </div>
  <hr />

  <div class="button-container w-100">
    <button class="btn btn-primary fw-bold" (click)="submitStep()">
      <a>Home</a>
    </button>
  </div>
</div>
